const KEEPER = {
  legal: ["Legal keeper", "bg-[#22C55E] text-black border-black"],
  undersized: ["Undersized — release", "bg-[#EF4444] text-white border-black"],
  oversized: ["Over slot — release", "bg-[#EF4444] text-white border-black"],
  no_size_limit: ["No size limit", "bg-[#22C55E] text-black border-black"],
  unknown: ["Size rule unknown", "bg-[#3F3F46] text-white border-black"],
};

const EDIBLE = {
  yes: ["Edible", "border-[#22C55E] text-[#22C55E]"],
  no: ["Not edible", "border-[#EF4444] text-[#EF4444]"],
  caution: ["Eat with caution", "border-[#EAB308] text-[#EAB308]"],
};

const base = "inline-block text-xs font-black uppercase tracking-wider px-2 py-1 border-2";

export function KeeperBadge({ status, testId = "keeper-badge" }) {
  const [label, cls] = KEEPER[status] || KEEPER.unknown;
  return <span data-testid={testId} className={`${base} ${cls}`}>{label}</span>;
}

export function EdibleBadge({ edible, testId = "edible-badge" }) {
  if (!edible) return null;
  const [label, cls] = EDIBLE[edible] || EDIBLE.caution;
  return <span data-testid={testId} className={`${base} ${cls}`}>{label}</span>;
}

export const ratingTier = (r) => (r == null ? "low" : r >= 8 ? "hot" : r >= 5 ? "mid" : "low");

export function RatingBlock({ rating, size = "md", testId = "rating-block" }) {
  const tier = ratingTier(rating);
  const cls = { hot: "bg-[#FF4D00] text-black", mid: "bg-[#EAB308] text-black", low: "bg-[#3F3F46] text-white" }[tier];
  const dim = size === "lg" ? "w-24 h-24 text-5xl" : "w-12 h-12 text-xl";
  return (
    <div data-testid={testId}
      className={`${cls} ${dim} font-display flex items-center justify-center border-2 border-black shadow-[3px_3px_0_0_#F4F4F5] shrink-0`}>
      {rating ?? "–"}
    </div>
  );
}

export const KEEPER_DISCLAIMER =
  "Keeper sizes are estimates only. Always check your official state fishing regulations before keeping a fish.";
